import Tracker from "@openreplay/tracker";
import logrocket from "logrocket";

let interactionCount = 0;
let tracker: Tracker = null;

// Function to initialize LogRocket
function initializeLogRocket() {
  if (process.env.NEXT_PUBLIC_LOGROCKET_KEY) {
    logrocket.init(process.env.NEXT_PUBLIC_LOGROCKET_KEY, {
      // console: {
      //   shouldAggregateConsoleErrors: true,
      // },
      network: {
        requestSanitizer: (request) => {
          if ((request.body as any)?.variables?.data?.password) {
            (request.body as any).variables.data.password = "";
          }

          return request;
        },
      },
      console: {
        isEnabled: false,
      },
    });
  } else {
    // console.log("starting log rocket");
  }
}

function initializeOpenRelay() {
  tracker = new Tracker({
    projectKey: process.env.NEXT_PUBLIC_OPENRELAY_KEY,
    network: {
      capturePayload: true,
    } as any,
    ingestPoint: "https://replay.captyn.com/ingest",
  });

  tracker.start();
}

// Event listeners for keyboard and mouse events
function interactionHandler() {
  interactionCount += 1;

  if (interactionCount >= 2) {
    initializeLogRocket();

    if (process.env.NEXT_PUBLIC_OPENRELAY_KEY) {
      initializeOpenRelay();
    }
    // Remove event listeners after initializing LogRocket
    document.removeEventListener("click", interactionHandler);
    document.removeEventListener("keydown", interactionHandler);
  }
}

// Adding event listeners to track user interactions
if (typeof window !== "undefined") {
  document.addEventListener("click", interactionHandler);
  document.addEventListener("keydown", interactionHandler);
}

export default logrocket;

export { tracker };
